import React from "react";

export default function InputInstagramUsername({ errors, register }) {
  return (
    <input
      className={`form-control ${errors.instagram_username && "is-invalid"}`}
      type="text"
      placeholder="@usuario"
      name="instagram_username"
      {...register("instagram_username", {
        pattern: {
          value: /^@.+$/,
          message: "El usuario debe empezar con @",
        },
      })}
    />
  );
}
